import ButtonCustom from '../atoms/button/ButtonCustom'
// import styles from './onboarding.module.css'
import styles from './boardingRoles.module.scss'

export const AccountRoleSelection = ({ setRole }) => {
	const roles = [
		{ key: 'user', label: "I'm a User", dataCy: 'user-role-onboarding' },
		{
			key: 'vendor',
			label: "I'm a Vendor",
			dataCy: 'vendor-role-onboarding',
		},
		{
			key: 'kazoo-planner',
			label: "I'm a Wedding Planner",
			dataCy: 'planner-role-onboarding',
		},
	]
	return (
		<div className={styles.roleSelect}>
			{/* <h2 className={styles.roleSelectTitle}>Who are you?</h2> */}
			<div className={styles.roleButtons}>
				{roles.map((role) => (
					<ButtonCustom
						variant="pilled"
						key={role.key}
						data-cy={role.dataCy}
						onClick={() => setRole(role.key)}
						className={styles.roleButton}
					>
						{role.label}
					</ButtonCustom>
				))}
			</div>
		</div>
	)
}
